import { createAction } from 'redux-api-middleware';
import { HUBBLE_SOCKET_TOKEN } from '../store/middleware/APIUrl';

const Types = {
    SOCKET_CONNECT: 'SOCKET_CONNECT',
    SOCKET_CONNECT_BLOCKING: 'SOCKET_CONNECT_BLOCKING',
    SOCKET_CONNECTING: 'SOCKET_CONNECTING',
    SOCKET_CONNECTED: 'SOCKET_CONNECTED',
    SOCKET_DISCONNECT: 'SOCKET_DISCONNECT',
    SOCKET_DISCONNECTING: 'SOCKET_DISCONNECTING',
    SOCKET_DISCONNECTED: 'SOCKET_DISCONNECTED',
    SOCKET_FETCH_CONNECTED_DEVICES: 'SOCKET_FETCH_CONNECTED_DEVICES',
    SOCKET_REBOOT_DEVICE: 'SOCKET_REBOOT_DEVICE',
    SOCKET_UPDATE_CONTENT: 'SOCKET_UPDATE_CONTENT',
    SOCKET_UPDATE_SETTINGS: 'SOCKET_UPDATE_SETTINGS',
    SOCKET_DEMAND_SCREENSHOT: 'SOCKET_DEMAND_SCREENSHOT',
    SOCKET_OPEN_STATUS_PANEL: 'SOCKET_OPEN_STATUS_PANEL',
    SOCKET_CLEAR_DEVICE_CACHE: 'SOCKET_CLEAR_DEVICE_CACHE',
    SOCKET_CLEAR_DEVICE_CONTENT: 'SOCKET_CLEAR_DEVICE_CONTENT',
    SOCKET_RESTART_APP: 'SOCKET_RESTART_APP',
    SOCKET_RELOAD_PROMO: 'SOCKET_RELOAD_PROMO',
    SOCKET_FETCH_CONNECTED_DEVICES_STORE_REQUEST: 'SOCKET_FETCH_CONNECTED_DEVICES_STORE##REQUEST',
    SOCKET_FETCH_CONNECTED_DEVICES_STORE_SUCCESS: 'SOCKET_FETCH_CONNECTED_DEVICES_STORE##SUCCESS',
    SOCKET_FETCH_CONNECTED_DEVICES_STORE_FAILURE: 'SOCKET_FETCH_CONNECTED_DEVICES_STORE##FAILURE',
}

/**
 * @deprecated
 */
export const Actions = Types

/**
 * Connect to socket server
 * @param {String} [url]
 */
function connect(url) {
    return {
        type: Types.SOCKET_CONNECT,
        payload: { url },
    }
}

/**
 * Connect to socket server
 * @param {String} [url]
 */
function connectBlocking(url) {
    return {
        type: Types.SOCKET_CONNECT_BLOCKING,
        payload: { url },
    }
}

/**
 * Disconnect from socket server
 */
function disconnect() {
    return {
        type: Types.SOCKET_DISCONNECT,
    }
}

/**
 * Reboot device
 * @param String uid Device ID
 * @param String groupId Group ID
 */
function rebootDevice(uid, groupId) {
    return {
        type: Types.SOCKET_REBOOT_DEVICE,
        payload: { groupId, uid },
    }
}

/**
 * Update device content
 * @param String uid Device ID
 * @param String groupId Group ID
 */
function updateContent(uid, groupId) {
    return {
        type: Types.SOCKET_UPDATE_CONTENT,
        payload: { groupId, uid },
    }
}

/**
 * Update device settings
 * @param String uid Device ID
 * @param String groupId Group ID
 */
function updateSettings(uid, groupId) {
    return {
        type: Types.SOCKET_UPDATE_SETTINGS,
        payload: { groupId, uid },
    }
}

/**
 * Demand device screenshot
 * @param String uid Device ID
 * @param String groupId Group ID
 */
function demandScreenshot(uid, groupId) {
    return {
        type: Types.SOCKET_DEMAND_SCREENSHOT,
        payload: { groupId, uid },
    }
}

/**
 * Fetch connected devices
 */
function fetchConnectedDevices() {
    return {
        type: Types.SOCKET_FETCH_CONNECTED_DEVICES,
    }
}

/**
 * Open Status Panel
 */
function openStatusPanel(uid) {
    return {
        type: Types.SOCKET_OPEN_STATUS_PANEL,
        payload: { uid },
    }
}

function clearDeviceCache(uid) {
    return {
        type: Types.SOCKET_CLEAR_DEVICE_CACHE,
        payload: { uid }
    }
}

function clearDeviceContent(uid) {
    return {
        type: Types.SOCKET_CLEAR_DEVICE_CONTENT,
        payload: { uid }
    }
}

/**
 * Restart app
 * @param String uid Device ID
 * @param String groupId Group ID
 */
function restartApp(uid, groupId) {
    return {
        type: Types.SOCKET_RESTART_APP,
        payload: { groupId, uid },
    }
}

/**
 * Reload promo
 * @param String uid Device ID
 * @param String groupId Group ID
 */
function reloadPromo(uid, groupId) {
    return {
        type: Types.SOCKET_RELOAD_PROMO,
        payload: { groupId, uid },
    }
}

/**
 * Fetch stores information
 */
export function fetchConnectedDevicesInStores(storeCode) {
    return createAction({
      endpoint: `${HUBBLE_SOCKET_TOKEN}/store/${storeCode}/devices`,
      method: 'GET',
      types: [
        Types.SOCKET_FETCH_CONNECTED_DEVICES_STORE_REQUEST,
        Types.SOCKET_FETCH_CONNECTED_DEVICES_STORE_SUCCESS,
        Types.SOCKET_FETCH_CONNECTED_DEVICES_STORE_FAILURE,
      ],
    });
  };

export {
    Types,
    connect,
    connectBlocking,
    disconnect,
    rebootDevice,
    updateContent,
    updateSettings,
    demandScreenshot,
    fetchConnectedDevices,
    openStatusPanel,
    restartApp,
    reloadPromo,
    clearDeviceCache,
    clearDeviceContent,
}
